import { type } from "../types/types";

export const set_store = (store) => (dispatch) => {
  dispatch({
    type: type.SET_STORE,
    store: store,
  });
};
